module.exports = __webpack_public_path__ + "static/palmer.33abbfeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/palmer.png
// module id = 499
// module chunks = 256317873200919